import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const DonationOption = (props) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: "rgba(255,255,255,0.08)",
        border: "1px solid rgba(255,255,255,0.16)",
        borderRadius: 2,
        p: { xs: 2.25, md: 3 },
        width: "100%",
        boxShadow: "0 18px 48px rgba(0,0,0,0.12)",
        backdropFilter: "blur(12px)",
        transition: "transform 180ms ease, background 180ms ease",
        "&:hover": {
          transform: "translateY(-4px)",
          bgcolor: "rgba(255,255,255,0.11)",
        },
      }}
    >
      <Typography
        variant="h4"
        component="h2"
        color={theme.palette.common.white}
        sx={{
          fontFamily: "Georgia, 'Times New Roman', serif",
          fontStyle: "italic",
          fontWeight: 500,
          mb: 2,
        }}
      >
        {props.name}
      </Typography>
      {props.content}
    </Box>
  );
};

export default DonationOption;
